//
// WARNING: this file was auto-generated by @phensley/cldr-compiler. DO NOT EDIT.
//

/* eslint-disable max-len */

/** @public */
export type UnitType =   'g-force' |  'meter-per-square-second' |  'arc-minute'
 |  'arc-second' |  'degree' |  'radian' |  'revolution' |  'acre'
 |  'bu-jp' |  'cho' |  'dunam' |  'hectare' |  'se-jp'
 |  'square-centimeter' |  'square-foot' |  'square-inch'
 |  'square-kilometer' |  'square-meter' |  'square-mile'
 |  'square-yard' |  'item' |  'karat'
 |  'milligram-ofglucose-per-deciliter'
 |  'millimole-per-liter' |  'mole' |  'percent' |  'permille'
 |  'permillion' |  'permyriad' |  'portion-per-1e9'
 |  'liter-per-100-kilometer' |  'liter-per-kilometer'
 |  'mile-per-gallon' |  'mile-per-gallon-imperial' |  'bit'
 |  'byte' |  'gigabit' |  'gigabyte' |  'kilobit' |  'kilobyte'
 |  'megabit' |  'megabyte' |  'petabyte' |  'terabit' |  'terabyte'
 |  'century' |  'day' |  'day-person' |  'decade' |  'hour'
 |  'microsecond' |  'millisecond' |  'minute' |  'month'
 |  'nanosecond' |  'night' |  'quarter' |  'second' |  'week'
 |  'year' |  'ampere' |  'milliampere' |  'ohm' |  'volt'
 |  'british-thermal-unit' |  'calorie' |  'electronvolt'
 |  'foodcalorie' |  'joule' |  'kilocalorie' |  'kilojoule'
 |  'kilowatt-hour' |  'therm-us'
 |  'kilowatt-hour-per-100-kilometer' |  'newton'
 |  'pound-force' |  'gigahertz' |  'hertz' |  'kilohertz'
 |  'megahertz' |  'dot' |  'dot-per-centimeter' |  'dot-per-inch'
 |  'em' |  'megapixel' |  'pixel' |  'pixel-per-centimeter'
 |  'pixel-per-inch' |  'astronomical-unit' |  'centimeter'
 |  'decimeter' |  'earth-radius' |  'fathom' |  'foot' |  'furlong'
 |  'inch' |  'jo-jp' |  'ken' |  'kilometer' |  'light-year'
 |  'meter' |  'micrometer' |  'mile' |  'mile-scandinavian'
 |  'millimeter' |  'nanometer' |  'nautical-mile' |  'parsec'
 |  'picometer' |  'point' |  'ri-jp' |  'rin' |  'shaku-cloth'
 |  'shaku-length' |  'solar-radius' |  'sun' |  'yard' |  'candela'
 |  'lumen' |  'lux' |  'solar-luminosity' |  'carat' |  'dalton'
 |  'earth-mass' |  'fun' |  'grain' |  'gram' |  'kilogram'
 |  'microgram' |  'milligram' |  'ounce' |  'ounce-troy' |  'pound'
 |  'solar-mass' |  'stone' |  'ton' |  'tonne' |  'gigawatt'
 |  'horsepower' |  'kilowatt' |  'megawatt' |  'milliwatt'
 |  'watt' |  'atmosphere' |  'bar' |  'gasoline-energy-density'
 |  'hectopascal' |  'inch-ofhg' |  'kilopascal' |  'megapascal'
 |  'millibar' |  'millimeter-ofhg' |  'pascal'
 |  'pound-force-per-square-inch' |  'beaufort'
 |  'kilometer-per-hour' |  'knot' |  'light-speed'
 |  'meter-per-second' |  'mile-per-hour' |  'celsius'
 |  'fahrenheit' |  'temperature' |  'kelvin' |  'newton-meter'
 |  'pound-force-foot' |  'acre-foot' |  'barrel' |  'bushel'
 |  'centiliter' |  'cubic-centimeter' |  'cubic-foot'
 |  'cubic-inch' |  'cubic-kilometer' |  'cubic-meter'
 |  'cubic-mile' |  'cubic-yard' |  'cup' |  'cup-jp'
 |  'cup-metric' |  'deciliter' |  'dessert-spoon'
 |  'dessert-spoon-imperial' |  'dram' |  'drop' |  'fluid-ounce'
 |  'fluid-ounce-imperial' |  'gallon' |  'gallon-imperial'
 |  'hectoliter' |  'jigger' |  'koku' |  'kosaji' |  'liter'
 |  'megaliter' |  'milliliter' |  'osaji' |  'pinch' |  'pint'
 |  'pint-metric' |  'quart' |  'quart-imperial' |  'sai' |  'shaku'
 |  'tablespoon' |  'teaspoon' |  'to-jp';

/** @public */
export type UnitCategory =   'acceleration' |  'angle' |  'area' |  'concentr'
 |  'consumption' |  'digital' |  'duration' |  'electric'
 |  'energy' |  'force' |  'frequency' |  'graphics' |  'length'
 |  'light' |  'mass' |  'power' |  'pressure' |  'speed'
 |  'temperature' |  'torque' |  'volume';
